module.exports = __webpack_public_path__ + "static/media/2024-04-10-01.29eacc8e.png";